// extracted by mini-css-extract-plugin
export var chevron = "_lf-2";
export var chevronRotated = "_lf-3";
export var header = "_lf-1";
export var section = "_lf-0";